module.exports = __webpack_public_path__ + "static/img/glovo_gestion.d9b17d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/glovo_gestion.png
// module id = uZqR
// module chunks = 4